export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black mt-24">
      <div className="px-6 md:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/logo.png" alt="Ceinaru Media" className="h-8 w-8" />
            <span className="font-display font-extrabold text-lg tracking-tight">CEINARU<span className="text-[#D90429]"> MEDIA</span></span>
          </div>
          <p className="text-sm text-[#A0A0A0] max-w-xs leading-relaxed">
            A cozy recording facility built for artists who refuse to compromise on vision.
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#A0A0A0] mb-4">Visit</p>
          <p className="text-sm text-white/80">36A Calea Moșilor<br/>Open 10:00 – 18:00 Daily</p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#A0A0A0] mb-4">Contact</p>
          <p className="text-sm text-white/80">ceinaru@icloud.com<br/>+40 734 207 961</p>
        </div>
      </div>
      <div className="px-6 md:px-12 lg:px-20 py-6 border-t border-white/10 text-xs text-[#A0A0A0] uppercase tracking-[0.2em]">
        © {new Date().getFullYear()} Ceinaru Media — Pay at studio. No card required.
      </div>
    </footer>
  );
}
